import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  selectAllBlendsLocked,
  selectBlendFormMode,
  selectBlends,
  selectBlendSaveError,
  selectBlendSaving,
  selectBlendsLoading,
  selectCurrentBlend,
  selectGroupTemplates,
  selectGroupTemplateSaveError,
  selectGroupTemplateSaving,
  selectGroupTemplatesError,
  selectGroupTemplatesLoading,
  selectIsLoading,
  selectSuppliers,
} from './supplier.selectors';

@Injectable({ providedIn: 'root' })
export class SupplierSelectorsFacade {
  private readonly _store = inject(Store);

  public readonly isLoading = this._store.selectSignal(selectIsLoading);

  public readonly suppliers = this._store.selectSignal(selectSuppliers);

  public readonly blends = this._store.selectSignal(selectBlends);

  public readonly blendsLoading = this._store.selectSignal(selectBlendsLoading);

  public readonly allBlendsLocked = this._store.selectSignal(
    selectAllBlendsLocked,
  );

  public readonly blendFormMode = this._store.selectSignal(selectBlendFormMode);

  public readonly selectedBlend = this._store.selectSignal(selectCurrentBlend);

  public readonly blendSaving = this._store.selectSignal(selectBlendSaving);

  public readonly blendSaveError =
    this._store.selectSignal(selectBlendSaveError);

  public readonly groupTemplates =
    this._store.selectSignal(selectGroupTemplates);

  public readonly groupTemplatesLoading = this._store.selectSignal(
    selectGroupTemplatesLoading,
  );

  public readonly groupTemplatesError = this._store.selectSignal(
    selectGroupTemplatesError,
  );

  public readonly groupTemplateSaving = this._store.selectSignal(
    selectGroupTemplateSaving,
  );

  public readonly groupTemplateSaveError = this._store.selectSignal(
    selectGroupTemplateSaveError,
  );
}
